import React, { useEffect } from 'react';
import './MarketCategoryDrawer.css';

const ITEMS = [
  { key: 'All', label: 'All' },
  { key: 'Barter', label: 'Barter' },
  { key: 'Physical Products', label: 'Physical' },
  { key: 'Digital Products', label: 'Digital' },
  { key: 'Services', label: 'Services' },
];

export default function MarketCategoryDrawer({
  open,
  value = 'All',
  onClose,
  onSelect,
}) {
  // Close on Escape
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="popup-backdrop mcd-backdrop" onClick={onClose}>
      <div
        className="mcd-sheet"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Marketplace categories"
      >
        <div className="mcd-handle" />

        <div className="mcd-header">
          <div className="mcd-title">Categories</div>
          <button className="mcd-close" onClick={onClose} aria-label="Close" type="button">
            ✕
          </button>
        </div>

        <div className="mcd-list">
          {ITEMS.map((it) => {
            const isActive = value === it.key;
            return (
              <button
                key={it.key}
                className={`mcd-item ${isActive ? 'active' : ''}`}
                onClick={() => onSelect?.(it.key)}
                type="button"
              >
                <span className="mcd-radio" aria-hidden="true" />
                <span className="mcd-label">{it.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
